export default __webpack_public_path__ + "static/media/users-solid.24182c7e.svg";